import { render } from "./Loader.vue?vue&type=template&id=257f3b20"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=257f3b20&lang=scss"
script.render = render

export default script